import { Dispatch, FC, SetStateAction } from 'react';
import { Link } from 'react-router-dom';
import { HStack } from '@chakra-ui/react';

import { TeamMembersRequestStatus } from '__generated__/GQL';
import Chip from 'components/_core/Chip';

import * as routes from '../../../../routes';
import { useRequests } from '../../hooks/useRequests';
import { RequestsFilterState } from '../../types';
import { RequestsFilterStateToStatus } from '../../utils';
import locales from './locales';

interface FilterBarProps {
  currentFilterState: RequestsFilterState;
  onStatusChange: Dispatch<SetStateAction<TeamMembersRequestStatus[]>>;
}

const allFilterStates = Object.values(RequestsFilterState);

const FilterBar: FC<FilterBarProps> = ({
  currentFilterState,
  onStatusChange,
}) => {
  const { pageInfo } = useRequests([TeamMembersRequestStatus.Pending], {
    fetchPolicy: 'cache-only',
  });

  return (
    <HStack spacing="space-16" wrap="wrap">
      {allFilterStates.map((filterState) => (
        <Link key={filterState} to={routes.getStatePath(filterState)}>
          <Chip
            isActive={filterState === currentFilterState}
            onClick={() =>
              onStatusChange(RequestsFilterStateToStatus[filterState])
            }
          >
            {locales.formatString(locales.filters[filterState], {
              count: pageInfo.totalCount,
            })}
          </Chip>
        </Link>
      ))}
    </HStack>
  );
};

export default FilterBar;
